const utils = {
  getSafeImageUrl: function getSafeImageUrl(url) {
    return `https://buffer.com/cdn-cgi/image/dpr=2,w=274,f=auto/${url}`;
  }
};

export default utils;



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/utils/index.js
 **/